module.exports = __webpack_public_path__ + "static/media/notFound.6267f4bd.svg";